function customGtmEventsInit() {
  document.addEventListener('click', (event) => {
    if (window.location.hash === '#click-testing') {
      event.preventDefault();
    }

    const linkTarget = event.target.href ? event.target : event.target.closest('a');

    const now = Date.now();
    const date = new Date(now);
    const formattedDate = date.toISOString().split('T')[0]; // YYYY-MM-DD
    const formattedTime = date.toTimeString().split(' ')[0]; // HH:MM:SS

    const globalEventData = {
      page_url: window.location.href,
      date: formattedDate,
      time: formattedTime,
    };

    if (linkTarget?.matches('.header__inline-menu a') || linkTarget?.matches('#menu-drawer a')) {
      Shopify.analytics.publish('nav_link_click', {
        link_url: linkTarget.href,
        link_text: linkTarget.innerText,
        ...globalEventData,
      });
    }

    if (event.target.matches('.page-width .klaviyo-form form button')) {
      Shopify.analytics.publish('insider_signup', {
        ...globalEventData,
      });
    }

    if (linkTarget?.matches('a[href="/pages/stores"]')) {
      Shopify.analytics.publish('store_locator_link_click', {
        ...globalEventData,
      });
    }

    if (linkTarget?.matches('.list-social__link')) {
      Shopify.analytics.publish('social_link_click', {
        link_url: linkTarget.href,
        ...globalEventData,
      });
    }

    if (linkTarget?.matches('[data-create-account-link]')) {
      Shopify.analytics.publish('create_account_link_click', {
        ...globalEventData,
      });
    }

    if (linkTarget?.href?.includes('custom-build')) {
      Shopify.analytics.publish('customize_link_click', {
        model_url: linkTarget.href,
        ...globalEventData,
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  customGtmEventsInit();
});
